module.exports = __webpack_public_path__ + "static/img/EE@2x.ada619bb.jpg";